import { H1 } from '@liveauctioneers/hammer-ui-core/text';
import { memo, ReactNode } from 'react';
import isEqual from 'react-fast-compare';

type Props = {
    callToAction?: ReactNode;
    className?: string;
    title: ReactNode;
};

const PageTitleComponent = ({ callToAction, className, title }: Props) => {
    if (!title) {
        return null;
    }
    return (
        <section className="flex justify-between">
            <H1
                className={`${className ?? ''} mt-lg mb-md block`}
                data-testid="pageTitle"
            >
                {title}
            </H1>
            {Boolean(callToAction) && <span className="mt-2xl">{callToAction}</span>}
        </section>
    );
};

export const PageTitle = memo<Props>(PageTitleComponent, isEqual);
